import { Epic, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '../../../actions';
import { CLEAR_INTERNAL_BANNER, ClearInternalBanner } from '../../../actions/bannersEdit/internal/clearInternalBanner';
import {
    RemoveInternalBannerImage,
    removeInternalBannerImageAction
} from '../../../actions/imageEditor/internal/removeInternalBannerImage';
import { EpicDeps } from '../../../service/StoreFactory';
import { GdResourceType } from '../../../typings/graphql-grid';
import { State } from '../../../typings/state';

type EpicActions = RemoveInternalBannerImage;

const getClearInternalBannersActions = (state: State, action: ClearInternalBanner): EpicActions[] => {
    return (action.resources || []).reduce<EpicActions[]>((acc, resource) => {
        if (resource.type === GdResourceType.IMAGE) {
            acc.push(removeInternalBannerImageAction(action.bannerId, resource.id));
        }

        return acc;
    }, []);
};

export const clearInternalBannerEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.pipe(
        ofType(CLEAR_INTERNAL_BANNER),
        mergeMap(
            (action: ClearInternalBanner): Observable<EpicActions> => {
                return of(...getClearInternalBannersActions(store$.value, action));
            }
        )
    );
};
